//-----------------------------------------------------------------------
//-----------------------------------------------------------------------
// CURRENT

import React, { useState, useEffect } from 'react';
import styles from './VideoOver.module.css';
import { FaExpand, FaCompress, FaTimes  } from 'react-icons/fa';
import { generateFirebaseId } from '../../../Helpers/generateAFirebaseId';
import { getURLParams } from '../../../Helpers/getURLParams';

const VideoOver = ({ src }) => {
  const current_video_id = getURLParams(['video_id']);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [videoId, setVideoId] = useState(generateFirebaseId());

  useEffect(() => {
    if (current_video_id.video_id === null) {
      setIsExpanded(false);
    }
  }, [current_video_id.video_id]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    const handleScroll = () => {
      if (isExpanded) {
        setIsExpanded(false); // Contraer el video si se detecta scroll y está expandido
      }
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isExpanded]);

  const handleToggle = (event) => {
    event.stopPropagation(); // Evitar la propagación de clics al contenedor padre
    setIsExpanded((prev) => !prev);
    if (isExpanded) {
      // window.history.replaceState(null, '', '/');
    } else {
      if (current_video_id.video_id === null) {
        window.history.pushState(null, '', `/?video_id=${videoId}`);
      }
    }
  };

  const handleVideoClick = () => {
    if (isExpanded) {
      setIsExpanded(false); // Contraer el video al hacer clic si ya está expandido
      // window.history.replaceState(null, '', '/');
    } else {
      setIsExpanded(true); // Expandir el video al hacer clic si está contraído
      if (current_video_id.video_id === null) {
        window.history.pushState(null, '', `/?video_id=${videoId}`);
      }
    }
  };

  // Si no es mobile, no renderizar el componente
  if (!isMobile) return null;

  return (
    <>
      {/* Fondo negro con opacidad */}
      {isExpanded && (
        <div className={styles.overlayBackground} onClick={handleVideoClick}></div>
      )}
      <div onClick={handleVideoClick} className={`${styles.videoContainer} ${isExpanded ? styles.expanded : ''}`}>
        <video
          preload="none"
          playsInline
          src={src}
          muted={!isExpanded}
          
          autoPlay
          loop
          controls={false}
          className={styles.videoElement}
          onClick={handleVideoClick} // Añadir evento de clic en el video
        />
        <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
          {isExpanded && (
            // <FaTimes style={{color:"white"}} size={20} />
            <div style={{marginTop:"-25px", color:"white", borderRadius:"15px", border:"2px solid white", padding:"5px 10px 7px 10px", backgroundColor:"black", display:"flex", alignItems:"center", fontWeight:"bold", textAlign:"center"}}>
              Cerrar video
              <span style={{marginLeft:"10px"}}><FaTimes size={20} /> </span>
            </div>
          )}
        </div>
        <div className={styles.icon} onClick={handleToggle}>
          {isExpanded ? <FaTimes size={20} /> : <FaExpand size={20} />}
        </div>
      </div>
    </>
  );
};

export default VideoOver;


//-----------------------------------------------------------------------------------------------------------------
//-----------------------------------------------------------------------------------------------------------------
// OLD

// import React, { useState, useEffect } from 'react';
// import styles from './VideoOver.module.css';
// import { FaExpand, FaCompress } from 'react-icons/fa';
// import { generateFirebaseId } from '../../../Helpers/generateAFirebaseId';
// import { getURLParams } from '../../../Helpers/getURLParams';

// const VideoOver = ({ src }) => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [videoId, setVideoId] = useState(generateFirebaseId())
//   const current_video_id = getURLParams(["video_id"])
//   // const videoId = generateFirebaseId();

//   useEffect(() => {
//     if (current_video_id.video_id === null) {
//       setIsExpanded(false)
//     }
//   }, [current_video_id.video_id])

//   // Listener para cambiar el estado cuando cambie el tamaño de la ventana
//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     const handleScroll = () => {
//       if (isExpanded) {
//         setIsExpanded(false); // Contraer el video si se detecta scroll y está expandido
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, [isExpanded]);

//   const handleToggle = (event) => {
//     event.stopPropagation(); // Evitar la propagación de clics al contenedor padre
//     setIsExpanded((prev) => !prev);
//     if (isExpanded) {
//       window.history.replaceState(null, '', '/');
//     } else {
//       window.history.pushState(null, '', `/?video_id=${videoId}`)
//     }
//   };

//   const handleVideoClick = () => {
//     if (isExpanded) {
//       setIsExpanded(false); // Contraer el video al hacer clic si ya está expandido
//       window.history.replaceState(null, '', '/');
//     } else {
//       setIsExpanded(true); // Expandir el video al hacer clic si está contraído
//       window.history.pushState(null, '', `/?video_id=${videoId}`)
//     }
//   };

//   // Si no es mobile, no renderizar el componente
//   if (!isMobile) return null;

//   return (
//     <div onClick={handleVideoClick} className={`${styles.videoContainer} ${isExpanded ? styles.expanded : ''}`}>
//       <video
//         src={src}
//         muted={!isExpanded}
//         autoPlay
//         loop
//         controls={false}
//         className={styles.videoElement}
//         onClick={handleVideoClick} // Añadir evento de clic en el video
//       />
//       <div className={styles.icon} onClick={handleToggle}>
//         {isExpanded ? <FaCompress size={20} /> : <FaExpand size={20} />}
//       </div>
//     </div>
//   );
// };

// export default VideoOver;

